import React, { useContext, useEffect } from "react";
import { AuthContext } from "@context/AuthContext";
import type { ILangButton } from "@src/types/AppTypes";

const LangButton: React.FC<ILangButton> = ({
  showLangButton,
  mobileView,
  buttonSytles,
  iconStyles,
}) => {
  const auth = useContext(AuthContext);
  useEffect(() => {
    if (mobileView || (!mobileView && auth)) {
      setTimeout(() => {
        const el = document.getElementsByClassName("goog-te-gadget");
        for (const e of el) {
          e.classList.add("footer-goog-te-gadget");
        }
      }, 500);
    } else {
      setTimeout(() => {
        const el = document.getElementsByClassName("goog-te-gadget");
        for (const e of el) {
          e.classList.remove("footer-goog-te-gadget");
        }
      }, 500);
    }
  }, [mobileView, auth]);

  return (
    <>
      {showLangButton && (mobileView !== undefined ? mobileView : true) ? (
        <button
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
          id="google_translate_element"
          className={buttonSytles}
        >
          <i className={iconStyles}></i>
        </button>
      ) : null}
    </>
  );
};

export default LangButton;
